import { startsWith } from "@/util/StringUtils"

const catchImport = (error: any) => {
  const isChunkLoadFailed =
    startsWith(error.message, "Loading chunk") ||
    startsWith(error.message, "Loading CSS chunk") ||
    startsWith(error.message, "Failed to fetch dynamically")
  if (isChunkLoadFailed) {
    location.reload()
  }
}

const Path = {
  Auth: {
    SignIn: {
      path: "/signin",
      name: "SignIn",
      component: () => import("@/auth/view/SignIn.vue").catch(catchImport),
      single: true,
    },
  },
  NotFound: {
    path: "/404",
    name: "404",
    component: () => import("@/common/view/404.vue").catch(catchImport),
    single: true,
    forProxy: true,
  },
  Home: {
    path: "/",
    name: "Home",
    component: () => import("@/common/view/home/Home.vue").catch(catchImport),
    requireAuth: true,
    single: true,
  },
  Common: {
    Welcome: {
      path: "/welcome",
      name: "Welcome",
      component: () => import("@/common/view/Welcome.vue").catch(catchImport),
      requireAuth: true,
    },
  },
  Settings: {
    Settings: {
      path: "/settings",
      name: "Settings",
      component: () => import("@/settings/view/Settings.vue").catch(catchImport),
      requireAuth: true,
    },
    InvalidLicense: {
      path: "/invalid-license",
      name: "InvalidLicense",
      component: () => import("@/settings/view/InvalidLicense.vue").catch(catchImport),
      single: true,
    },
  },
  ActionHistory: {
    List: {
      path: "/history/list",
      name: "ActionHistoryList",
      component: () => import("@/history/view/ActionHistoryList.vue").catch(catchImport),
      requireAuth: true,
    },
  },
  Role: {
    List: {
      path: "/role/list",
      name: "RoleList",
      component: () => import("@/role/view/list/RoleList.vue").catch(catchImport),
      requireAuth: true,
    },
  },
  User: {
    Detail: {
      path: "/user/:userId",
      name: "UserDetail",
      props: true,
      component: () => import("@/user/view/detail/UserDetail.vue").catch(catchImport),
      build(userId: string) {
        return `/user/${userId}`
      },
      requireAuth: true,
    },
    List: {
      path: "/user/list",
      name: "UserList",
      component: () => import("@/user/view/list/UserList.vue").catch(catchImport),
      requireAuth: true,
    },
  },
  Prisoner: {
    PrisonerList: {
      path: "/prisoner/prisoner-list",
      name: "PrisonerList",
      component: () => import("@/prisoner/view/prisonerList/PrisonerList.vue").catch(catchImport),
      requireAuth: true,
    },
    FamilyList: {
      path: "/prisoner/family-list",
      name: "Families",
      component: () => import("@/prisoner/view/family/list/FamilyList.vue").catch(catchImport),
      requireAuth: true,
    },
  },
  Order: {
    OrderList: {
      path: "/order/list",
      name: "OrderList",
      component: () => import("@/order/view/orderList/OrderList.vue").catch(catchImport),
      requireAuth: true,
    },
    RechargeStatics: {
      path: "/order/recharge-statics",
      name: "RechargeStatics",
      component: () => import("@/order/view/prisonerList/PrisonerList.vue").catch(catchImport),
      requireAuth: true,
    },
    Detail: {
      path: "/order/:orderId",
      name: "OrderDetail",
      props: true,
      component: () => import("@/order/view/OrderDetail.vue").catch(catchImport),
      build(orderId: string) {
        return `/order/${orderId}`
      },
      requireAuth: true,
    },
  },
  RechargeRule: {
    List: {
      path: "/recharge-rule/list",
      name: "RechargeRuleList",
      component: () => import("@/rechargeRule/view/RechargeRuleList.vue").catch(catchImport),
      requireAuth: true,
    },
  },
  Recharge: {
    Recharge: {
      path: "/recharge/recharge",
      name: "Recharge",
      component: () => import("@/recharge/view/recharge/Recharge.vue").catch(catchImport),
      single: true,
      forProxy: true,
    },
    SelectPayment: {
      path: "/recharge/select-payment",
      name: "SelectPayment",
      component: () => import("@/recharge/view/SelectPayment.vue").catch(catchImport),
      single: true,
      forProxy: true,
    },
    PaymentResult: {
      path: "/recharge/payment-result",
      name: "PaymentResult",
      component: () => import("@/recharge/view/PaymentResult.vue").catch(catchImport),
      single: true,
      forProxy: true,
    },
    Wechatpay: {
      path: "/recharge/wechatpay",
      name: "Wechatpay",
      component: () => import("@/recharge/view/Wechatpay.vue").catch(catchImport),
      single: true,
      forProxy: true,
    },
  },
  Qna: {
    ManagementList: {
      path: "/qna/management-list",
      name: "QnaManagementList",
      component: () => import("@/qna/view/qnaList/QnaList.vue").catch(catchImport),
      requireAuth: true,
    },
    List: {
      path: "/qna/list",
      name: "QnaList",
      component: () => import("@/qna/view/Qnas.vue").catch(catchImport),
      single: true,
      forProxy: true,
    },
  },
  Test: {
    Test: {
      path: "/test",
      name: "Test",
      component: () => import("@/test/view/Test.vue").catch(catchImport),
      requireAuth: true,
    },
  },
}

export default Path
